import Regions from './Regions'

export default Regions
